import BaseScreen from "./BaseScreen";
import NavBar from "../components/NavBar";

import { Text, View, ScrollView, Button, Pressable } from "react-native";
import { color_333333, color_F1F1F1, white } from "../assets/style/colors";
import { MainNavProps } from "./navigation/main/MainParamList";
import { ScreenModal } from "../components/ScreenModal";

export const AnnouncementDetail = ({
  route,
  navigation,
}: MainNavProps<"AnnouncementDetail">) => {
  const { title, content, url } = route.params;

  return (
    <ScreenModal>
      <BaseScreen navVis navBarColor={"transparent"}>
        <NavBar title={title} showBack={false} />
        <ScrollView>
          <View
            style={{
              borderRadius: 16,
              borderRightWidth: 1,
              padding: 24,
              margin: 24,
              borderRightColor: color_F1F1F1,
              backgroundColor: white,
            }}
          >
            <Text
              style={{
                fontSize: 18,
                color: color_333333,
                lineHeight: 28,
              }}
            >
              {content}
            </Text>
          </View>
          {url && (
            <Pressable
              onPress={() => {
                navigation.navigate("CommonWeb", { url: url });
              }}
              style={{
                width: "100%",
                alignItems: "center",
                flexDirection: "row",
                paddingHorizontal: 24,
                marginBottom: 24,
              }}
            >
              <Text
                style={{
                  padding: 16,
                  marginHorizontal: 0,
                  borderRadius: 12,
                  flex: 1,
                  textAlign: "center",
                  backgroundColor: "white",
                  fontSize: 18,
                  color: "blue",
                  lineHeight: 26,
                }}
              >
                {url}
              </Text>
            </Pressable>
          )}
        </ScrollView>
      </BaseScreen>
    </ScreenModal>
  );
};
